import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSpinModule } from 'ng-zorro-antd/spin';

import { AvatarModule } from '@libs/src/avatar/avatar.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { ProfileUnsavedChangesDialogModule } from '@main-client/src/app/profile/profile-unsaved-changes-dialog/profile-unsaved-changes-dialog.module';
import { UploadModule } from '@main-client/src/app/upload/upload.module';

import { AccountBackend } from '@libs/src/account/account.backend';
import { AccountEditService } from '@main-client/src/app/account/account-edit.service';
import { FormValidatorService } from '@main-client/src/app/form/form-validator.service';
import { ProfileIntroEditDialogService } from '@main-client/src/app/profile/profile-intro-edit-dialog/profile-intro-edit-dialog.service';

import { ProfileIntroEditDialogComponent } from './profile-intro-edit-dialog.component';

@NgModule({
  declarations: [ProfileIntroEditDialogComponent],
  exports: [ProfileIntroEditDialogComponent],
  imports: [
    AvatarModule,
    CommonModule,
    FlexLayoutModule,
    FormsModule,
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatMenuModule,
    NzIconModule,
    NzSpinModule,
    ProfileUnsavedChangesDialogModule,
    ReactiveFormsModule,
    TtcMatInputModule,
    UploadModule,
  ],
  providers: [
    AccountEditService,
    AccountBackend,
    FormValidatorService,
    ProfileIntroEditDialogService,
  ],
})
export class ProfileIntroEditDialogModule {}
